module.exports = __webpack_public_path__ + "images/marketing/peeps/matt_debusk.jpg";